import Intl from '@fx-ui/intl';
import { get } from '@libs/shared';

/**
 * 获取错误文案
 *
 * @param error
 */
export const getErrorMsg = (error: any) => {
    const code = get(error, 'code');
    if (!code) {
        return '';
    }
    return Intl.get(`error.${code}`, {}, Intl.get('error.status.400'));
};
